// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  min-height: 100%;
  background-color: #f5f5f5;
  margin: 0;
}
.no-margin-top {
  margin-top: 0 !important;
}
.container {
  width: 100%;
  max-width: 1325px;
  margin: auto;
}
.header-button {
  color: lightgray;
}
.header-button:hover {
  color: white !important;
}
.ant-layout-sider-trigger {
  border-right: 1px solid #f0f0f0;
}
h2.select-project-title {
  font-size: 16px;
  margin: 0;
  line-height: 64px;
  color: lightgray;
  transition: all 0.2s;
}
h2.select-project-title:hover {
  color: white;
  cursor: pointer;
}
.select-dataset-item {
  transition: all 0.2s;
  border-radius: 7px;
  cursor: pointer;
}
.select-dataset-item .ant-avatar {
  background-color: #8c8c8c;
}
.select-dataset-item:hover {
  background-color: #e6f4ff;
}
.select-dataset-item:hover .ant-avatar {
  color: #e6f4ff;
}
.select-dataset-item.selected,
.select-dataset-item.selected:hover {
  background-color: #91caff;
}
.select-dataset-item.selected .ant-avatar {
  background-color: #0958d9;
  color: #91caff;
}
/* BEGIN about HTML styling */
/* Elements which are the first child of the about content container shouldn't have the default top margin */
.about-content *:first-child {
  margin-top: 0;
}
/* Images should scale proportionally with container width */
.about-content img {
  max-width: 100%;
  height: auto;
}
/* END about HTML styling */
/* BEGIN search results pane */
.search-results-pane {
  padding-bottom: 8px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.search-result-statistic.enabled {
  padding: 8px 16px;
  margin-left: -16px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* from antd */
}
.search-result-statistic.enabled:hover {
  border-color: #4096ff;
}
.search-result-statistic.selected {
  background-color: #fafafa;
}
.search-result-statistic.enabled.selected {
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02), inset 0 2px 5px rgba(0, 0, 0, 0.08);
}
.dataset-provenance-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 600px));
  gap: 20px;
}
.slick-arrow {
  color: black !important;
  /* override slick-next/slick-prev color */
}
.slick-dots li button {
  background-color: black !important;
  /* override slick-dots color */
}
/* END search results pane */
@media (min-width: 1050px) and (max-width: 1550px) {
  .dataset-provenance-card-grid {
    /* This looks better at an intermediate screen width */
    grid-template-columns: repeat(auto-fit, minmax(350px, 0.5fr));
  }
}
@media (max-width: 768px) {
  .ant-layout-content {
    padding: 10px !important;
  }
  .dataset-provenance-card-grid {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAA;EACA,yBAAA;EACA,SAAA;AACF;AAEA;EACE,wBAAA;AAAF;AAGA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;AADF;AAIA;EACE,gBAAA;AAFF;AAKA;EACE,uBAAA;AAHF;AAMA;EACE,+BAAA;AAJF;AAOA;EACE,eAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EAEA,oBAAA;AANF;AASA;EACE,YAAA;EACA,eAAA;AAPF;AAUA;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;AARF;AAWA;EACE,yBAAA;AATF;AAYA;EACE,yBAAA;AAVF;AAaA;EACE,cAAA;AAXF;AAcA;;EAEE,yBAAA;AAZF;AAeA;EACE,yBAAA;EACA,cAAA;AAbF;AACA,6BAA6B;AAC7B,4GAA4G;AAkB5G;EACE,aAAA;AAhBF;AACA,4DAA4D;AAmB5D;EACE,eAAA;EACA,YAAA;AAjBF;AACA,2BAA2B;AAC3B,8BAA8B;AAuB9B;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AArBF;AAwBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,yBAAA;EACA,uCAAA;EACA,yDAAA;EAvBA,cAAc;AAChB;AAyBA;EACE,qBAAA;AAvBF;AA0BA;EACE,yBAAA;AAxBF;AA2BA;EACE,4EAAA;AAzBF;AA4BA;EACE,aAAA;EACA,6DAAA;EACA,SAAA;AA1BF;AA6BA;EACE,uBAAA;EA3BA,yCAAyC;AAC3C;AA6BA;EACE,kCAAA;EA3BA,8BAA8B;AAChC;AACA,4BAA4B;AA+B5B;EACE;IA7BE,sDAAsD;IA+BtD,6DAAA;EA7BF;AACF;AAgCA;EACE;IACE,wBAAA;EA9BF;EAiCA;IACE,QAAA;EA/BF;AACF","sourcesContent":["html,\nbody {\n  min-height: 100%;\n  background-color: #f5f5f5;\n  margin: 0;\n}\n\n.no-margin-top {\n  margin-top: 0 !important;\n}\n\n.container {\n  width: 100%;\n  max-width: 1325px;\n  margin: auto;\n}\n\n.header-button {\n  color: lightgray;\n}\n\n.header-button:hover {\n  color: white !important;\n}\n\n.ant-layout-sider-trigger {\n  border-right: 1px solid #f0f0f0;\n}\n\nh2.select-project-title {\n  font-size: 16px;\n  margin: 0;\n  line-height: 64px;\n  color: lightgray;\n\n  transition: all 0.2s;\n}\n\nh2.select-project-title:hover {\n  color: white;\n  cursor: pointer;\n}\n\n.select-dataset-item {\n  transition: all 0.2s;\n  border-radius: 7px;\n  cursor: pointer;\n}\n\n.select-dataset-item .ant-avatar {\n  background-color: #8c8c8c;\n}\n\n.select-dataset-item:hover {\n  background-color: #e6f4ff;\n}\n\n.select-dataset-item:hover .ant-avatar {\n  color: #e6f4ff;\n}\n\n.select-dataset-item.selected,\n.select-dataset-item.selected:hover {\n  background-color: #91caff;\n}\n\n.select-dataset-item.selected .ant-avatar {\n  background-color: #0958d9;\n  color: #91caff;\n}\n\n\n/* BEGIN about HTML styling */\n\n/* Elements which are the first child of the about content container shouldn't have the default top margin */\n.about-content *:first-child {\n  margin-top: 0;\n}\n\n/* Images should scale proportionally with container width */\n.about-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* END about HTML styling */\n\n\n/* BEGIN search results pane */\n\n.search-results-pane {\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.search-result-statistic.enabled {\n  padding: 8px 16px;\n  margin-left: -16px;\n  border-radius: 8px;\n\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);\n  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1); /* from antd */\n}\n\n.search-result-statistic.enabled:hover {\n  border-color: #4096ff;\n}\n\n.search-result-statistic.selected {\n  background-color: #fafafa;\n}\n\n.search-result-statistic.enabled.selected {\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02), inset 0 2px 5px rgba(0, 0, 0, 0.08);\n}\n\n.dataset-provenance-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 600px));\n  gap: 20px;\n}\n\n.slick-arrow {\n  color: black !important; /* override slick-next/slick-prev color */\n}\n\n.slick-dots li button {\n  background-color: black !important; /* override slick-dots color */\n}\n\n/* END search results pane */\n\n\n@media (min-width: 1050px) and (max-width: 1550px) {\n  .dataset-provenance-card-grid {\n    /* This looks better at an intermediate screen width */\n    grid-template-columns: repeat(auto-fit, minmax(350px, 0.5fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-layout-content {\n    padding: 10px !important;\n  }\n\n  .dataset-provenance-card-grid {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
